import './Search.css';
import React, { useState, useEffect } from 'react';
import { getIndicador } from '../../services/IndicadoresService';
import { IndicadoresTable } from '../tabla/IndicadoresTable.jsx';
import ModalCreate from '../inidicador/modalcreate.js';

function IndicadoresSearch() {
  const [data, setData] = useState([]); 
  const [query, setQuery] = useState(''); 
  const [filteredData, setFilteredData] = useState([]);
  const [selectedArea, setSelectedArea] = useState('');
  const [selectedTema, setSelectedTema] = useState('');

  const fetchIndicadores = async () => {
    try {
      const { data } = await getIndicador();
      const items = data.map((area, index) => ({
        key: `area-${index}`,
        label: area.area,
        children: area.temas.map((tema) => ({
          key: `tema-${tema.tema_area_id}`,
          label: tema.tema_area,
          children: tema.indicadores.map((indicador) => ({
            key: `indicador-${indicador.codigo_indicador}`,
            label: indicador.descripcion,
            indicadorid: indicador.id,
            url: indicador.url,
          })),
        })),
      }));
      setData(items);
      setFilteredData(items);
    } catch (error) {
      console.error('Error al obtener indicadores:', error);
    }
  };

  useEffect(() => {
    fetchIndicadores();
  }, []);

  useEffect(() => {
    const filterItems = (items, query, area, tema) => {
      return items
        .map((item) => {
          if (area && item.label !== area) return null;

          const filteredTemas = item.children.map((temaItem) => {
            if (tema && temaItem.label !== tema) return null;

            const filteredIndicadores = temaItem.children.filter((indicador) =>
              indicador.label.toLowerCase().includes(query.toLowerCase())
            );

            if (filteredIndicadores.length === 0) return null;

            return {
              ...temaItem,
              children: filteredIndicadores,
            };
          }).filter((temaItem) => temaItem !== null);

          if (filteredTemas.length === 0) return null;

          return {
            ...item,
            children: filteredTemas,
          };
        })
        .filter((item) => item !== null);
    };

    setFilteredData(filterItems(data, query, selectedArea, selectedTema));
  }, [query, selectedArea, selectedTema, data]);

  const handleClearFilter = () => {
    setQuery('');
    setSelectedArea('');
    setSelectedTema('');
    setFilteredData(data);
  };

  const handleKeyDown = (e) => {
    const regex = /^[a-zA-Z0-9]+$/;
    if (!regex.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
      e.preventDefault();
    }
  };

  const handleUpdateData = () => {
    fetchIndicadores(); // Vuelve a obtener los indicadores actualizados
  };

  const allAreas = [...new Set(data.map((item) => item.label))];
  const allTemas = selectedArea
    ? [
      ...new Set(
        data
          .find((item) => item.label === selectedArea)?.children.map((child) => child.label) || []
      ),
    ]
    : [];

  return (
    <div>
      <div className='contet'>
        <div className='filtros'>
          <select
            value={selectedArea}
            onChange={(e) => {
              setSelectedArea(e.target.value);
              setSelectedTema(''); 
            }}
            className="select"
          >
            <option value="">Seleccionar Área</option>
            {allAreas
              .sort((a, b) => a.localeCompare(b))
              .map((area, index) => (
                <option key={index} value={area}>
                  {area}
                </option>
              ))}
          </select>

          <select
            value={selectedTema}
            onChange={(e) => setSelectedTema(e.target.value)}
            className="select"
            disabled={!selectedArea}
          >
            <option value="">Seleccionar Tema</option>
            {allTemas
              .sort((a, b) => a.localeCompare(b))
              .map((tema, index) => (
                <option key={index} value={tema}>
                  {tema}
                </option>
              ))}
          </select><input
          type="text"
          placeholder="Buscar Indicador"
          className="Search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <button onClick={handleClearFilter} className='limpiar' >
          Limpiar
        </button>
        <ModalCreate onCreate={handleUpdateData} />
        </div>
         {/* Pasa la función handleUpdateData */}
      </div>
      <IndicadoresTable data={filteredData} />
    </div >
  );
}

export { IndicadoresSearch };
